import { Fragment, useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { connect } from 'react-redux';
import { apiEndpoint } from './constants/api';
import { EmployerUserSearchTable } from './components/EmployerUserSearchTable';
import Modal from './components/Modal';
import { avatar } from './constants/Avatar';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: state.user.currentEmployer
}), {});
function Employer({ user, employer }) {
  const [employerData, setEmployerData] = useState({});
  const [employerUserData, setEmployerUserData] = useState([]);
  const [isOpened, setIsOpened] = useState(false);
  const { id } = useParams();

  const loadEmployerData = async (q) => {
    const { data } = await axios.get(apiEndpoint(`/admin/employer/${id}`));
    setEmployerData(data[0]);
    const { data: eUserData } = await axios.post(apiEndpoint(`/admin/employer/${id}/users`));
    setEmployerUserData(eUserData);
  };

  const updateActiveEmployer = (key, { target: { value } }) => {
    setEmployerData({ ...employerData, [key]: value });
  }

  const onSubmit = (evt) => {
    evt.preventDefault();
  }

  const saveEmployerData = async () => {
    const { data } = await axios.patch(apiEndpoint(`/admin/employer/${employerData.id}`), employerData);
    loadEmployerData();
    closeModal();
  }

  const closeModal = async () => {
    loadEmployerData();
    setIsOpened(false);
  };

  const openModal = async () => {
    loadEmployerData();
    setIsOpened(true);
  };

  useEffect(() => {
    loadEmployerData();
  }, []);
  return (
    <>
    <Helmet>
      <title>Employer | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div>
                <div className="w-full mb-2 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
                  <div className="flex gap-4">
                    <div className="flex items-center">
                      
                    </div>
                    <div>
                      <div>
                        <h1 className="text-4xl text-gray-800">
                          {employerData.name}
                        </h1>
                      </div>
                      <div>
                      <a
                          target="_blank"
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                          href={employerData.website} target="_blank">{employerData.website}</a>
                      </div>
                    </div>
                    <div className="grow flex-col">
                      <div className="flex justify-end">
                        <button
                          onClick={() => openModal()}
                          type="button"
                          className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="py-4">
                    {employerData.id && <EmployerUserSearchTable employerUserData={employerUserData} />}
                  </div>
                </div>
              </div>
              {/* /End replace */}
            </div>
            <Modal
              title="Edit Employer"
              isOpened={isOpened}
              onClose={closeModal}
              >
              <form onSubmit={onSubmit} className="w-full">
                <div className="text-lg text-left mb-5">
                  Edit Employer
                </div>
                <div className="my-5">
                  <label
                      htmlFor="project-name"
                      className="mb-2 text-lg font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Employer Name
                    </label>
                    <div className="relative">
                      <input
                        type="search"
                        value={employerData.name}
                        onChange={(d) => updateActiveEmployer('name', d)}
                        id="project-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Employer Name"
                        required
                      />
                    </div>
                </div>
                <div className="my-5">
                  <label
                      htmlFor="project-name"
                      className="mb-2 text-lg font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Employer Website
                    </label>
                    <div className="relative">
                      <input
                        type="search"
                        value={employerData.website}
                        onChange={(d) => updateActiveEmployer('website', d)}
                        id="project-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Employer Website"
                        required
                      />
                    </div>
                </div>
                <div className="my-2">
                  <button
                    type="button"
                    onClick={saveEmployerData}
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-lg inline-flex items-center px-5 py-2.5 text-center mr-2"
                  >
                    Update Employer
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-lg font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(Employer);